import { Theme } from "../../../../../components/constants";

export default {
    nextBtnDiv: {
        display: "flex",
        justifyContent: "flex-end",
    },
    gridActions: { 
        display: 'flex', 
        gap: '10px' 
    },
    gridColumnText: {
		fontSize: "16px",
		color: Theme.TEXT_PRIMARY_BLACK,
		whiteSpace: 'pre'
	},
    addBtnDiv: {
        display: "flex",
        justifyContent: "space-around",
    },
    addBtnStyles: {
        height: "fit-content",
    }
}